import {createGlobalStyle} from "styled-components";
import {breakpoints} from "@/styles/sizes";

export const lightTheme = {
  black:'#111',
  green:'#0e3325',
  lightGreen:'#859f95',
  gold:'#c49959',
  blue:'#033769',
  yellow:'#ffb446',
  grayText:'#212529',
  greenText:'#144733',
  grayBackground:'#ebebe8',
  lightGrayText:'#7c7c7c',
  divider:'#d9d9d3',
  red:'#FF5A5F',
};

export const darkTheme = {};

export const getColor = (color, theme = "light") => {
  return theme === "dark" ? darkTheme[color] : lightTheme[color];
};

export const GlobalStyles = createGlobalStyle`

  @font-face {
    font-family: 'Josefin Sans';
    src: url('/fonts/JosefinSans-Bold.woff2') format('woff2'); /* Modern browsers */
    font-weight: bold; /* Use "700" or "bold" for clarity */
    font-style: normal;
    font-display: swap; /* Helps with rendering */
  }

  @font-face {
    font-family: 'Josefin Sans';
    src: url('/fonts/JosefinSans-Regular.woff2') format('woff2'); /* Modern browsers */
    font-weight: 400; /* Use "400" for regular */
    font-style: normal;
    font-display: swap; /* Helps with rendering */
  }

  @font-face {
    font-family: 'Playfair Display';
    src: url('/fonts/PlayfairDisplay-Regular.woff2') format('woff2'); /* Modern browsers */
    font-weight: 400; /* Regular weight */
    font-style: normal;
    font-display: swap; /* Helps with rendering */
  }

  /* Works in Chrome, Safari, and Edge */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgb(190,154,97); /* scrollbar handle */
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background-color: white;  /* scrollbar track */
    border-radius: 4px;
  }



  //BASE CSS
  html{
    scroll-behavior: smooth;
    scroll-padding-top: 50px;
  }
  * {
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
    font-family: "Josefin Sans", sans-serif;
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  
  body{
    padding-top: 87px;//For fixed header
    @media only screen and (${breakpoints.mobile}) {
      padding-top: 67px;//For fixed header
    }
  }

  
  //TYPOGRAPHY
  h1,h2,h3,h4,h5,h6,p,a,span{
    margin:0; 
    padding:0;
  }
  h1,h2,h3,h4,h5,h5{
  }
  h1, .h1 {
    font-size:42px;
    line-height: 54px;
    font-weight: 700;
    margin: 0;
  }
  h2, .h2 {
    font-size:36px;
    line-height: 48px;
    font-weight: 500;
  }
  h3, .h3 {
    font-size:40px;
    line-height: 52px;
    font-weight: 400;
  }
  h4, .h4 {
    font-size:28px;
    line-height: 38px;
    font-weight: 500;
  }
  h5, .h5 {
    font-size:18px;
    line-height: 26px;
    font-weight: 500;
  }
  h6, .h6 {
    font-size:16px;
    line-height: 24px;
    font-weight: 500;
  }
  
  
  p,body,a,div {
    font-size: 16px;
    line-height: 24px;
    //font-weight: 400;
  }

  @media only screen and (${breakpoints.mobile}) {
    h1, .h1 {
      font-size: 33.5px;
      line-height: 40.5px;
    }
    h2, .h2 {
      font-size: 29px;
      line-height: 36px;
    }
    h3, .h3 {
      font-size: 32px;
      line-height: 39px;
    }
    h4, .h4 {
      font-size: 23px;
      line-height: 28.5px;
    }
    h5, .h5 {
      font-size: 15.5px;
      line-height: 19.5px;
    }
    h6, .h6 {
      font-size: 14px;
      line-height: 18px;
    }

    p, body, a, div {
      font-size: 14px;
    }
  }



  .container {
    width: 100%;
    max-width: 1440px!important;
    flex-shrink: 0!important;
    margin-left: auto;
    margin-right: auto;
  }

  .container_header {
    width: 100%;
    max-width: 1370px!important;
    flex-shrink: 0!important;
    margin-left: auto;
    margin-right: auto;
  }
  .container_slider, .container_small {
    width: 100%;
    max-width: 1220px!important;
    flex-shrink: 0!important;
    margin-left: auto;
    margin-right: auto;
  }

  .container_small_with_padding_20 {
    width: 100%;
    max-width: 1260px!important;
    flex-shrink: 0!important;
    margin-left: auto;
    margin-right: auto;
  }

  .container_private_form {
    width: 100%;
    max-width: 550px!important;
    flex-shrink: 0!important;
    margin-left: auto;
    margin-right: auto;
  }
  //OTHER
  .shadow {
    box-shadow: 0px 1px 15px rgba(2,11,32, 0.05);
  }

  .zoom {
    transition: transform .2s; /* Animation */
  }

  .zoom:hover {
    transform: scale(1.02); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
  }

  .flex-start {
    width: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
  }
  
  .flex-end {
    width: 100%;
    display: flex;
    justify-content: end;
    align-items: center;
  }
  
  .flex-center {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }


  .flex-between,.flex-between-center {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .flex-column {
    flex-direction: column;
    width: 100%;
    display: flex;
  }

  .cursor-pointer {
    cursor: pointer;
  }
 
.excelExportInput{
  //width: fit-content!important;
  width: 100%!important;
  input {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
  }
  input::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
  }
}

  .slick-track
  {
    display: flex !important;
  }

  .slick-slide
  {
    height: inherit !important;
  }


  .desktop_only{
    display: block!important;
  }
  .mobile_only{
    display: none!important;
  }
  @media only screen and (${breakpoints.mobile}) {
    .desktop_only{
      display: none!important;
    }
    .mobile_only{
      display: block!important;
    }
  }


  .desktop_only_flex{
    display: flex!important;
  }
  .mobile_only_flex{
    display: none!important;
  }
  @media only screen and (${breakpoints.mobile}) {
    .desktop_only_flex{
      display: none!important;
    }
    .mobile_only_flex{
      display: flex!important;
    }
  }

  .blue_block{
    background-color: #0a88ff;
    padding: 10px;
    color: #fff!important;
    margin-bottom: 20px;
    a,div,p,span,strong{
      color: #fff!important;
    }
  }

  @media only screen and (${breakpoints.mobile}) {
    .tourWhySection{
        margin-top: 0!important;
    }
    .tourMeetingSection{
        margin-top: 0!important;
    }
  }
  

  
`;
